import React from 'react';
export function DifferentiationSection() {
  return <section className="py-24 bg-white" data-id="element-57">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-58">
        <div className="bg-slate-50 rounded-3xl p-8 md:p-16 border border-slate-100" data-id="element-59">
          <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-60">
            <div data-id="element-61">
              <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" data-id="element-62">
                Why I'm Not Your Average <br data-id="element-63" />
                "Passionate Copywriter"
              </h2>
              <p className="text-lg text-slate-600 mb-8" data-id="element-64">
                Most copywriters focus on word count and "sounding nice." I
                focus on one metric:{' '}
                <span className="font-bold text-slate-900" data-id="element-65">
                  Revenue per visitor.
                </span>
              </p>
              <p className="text-lg text-slate-600 mb-8" data-id="element-66">
                I work with fewer clients intentionally so I can dive deep into
                your business model. I don't just hand over a Google Doc and
                disappear; I strategize with you on how to deploy the copy for
                maximum impact.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-67">
              <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-100" data-id="element-68">
                <div className="text-4xl font-bold text-emerald-600 mb-2" data-id="element-69">
                  ROI
                </div>
                <div className="text-slate-900 font-semibold" data-id="element-70">Focused</div>
                <p className="text-sm text-slate-500 mt-2" data-id="element-71">
                  I track conversions, not just clicks.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-100" data-id="element-72">
                <div className="text-4xl font-bold text-emerald-600 mb-2" data-id="element-73">
                  Psych
                </div>
                <div className="text-slate-900 font-semibold" data-id="element-74">Driven</div>
                <p className="text-sm text-slate-500 mt-2" data-id="element-75">
                  Based on behavioral psychology.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-100" data-id="element-76">
                <div className="text-4xl font-bold text-emerald-600 mb-2" data-id="element-77">
                  Deep
                </div>
                <div className="text-slate-900 font-semibold" data-id="element-78">Research</div>
                <p className="text-sm text-slate-500 mt-2" data-id="element-79">
                  I know your customer better than they do.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-100" data-id="element-80">
                <div className="text-4xl font-bold text-emerald-600 mb-2" data-id="element-81">
                  Zero
                </div>
                <div className="text-slate-900 font-semibold" data-id="element-82">Fluff</div>
                <p className="text-sm text-slate-500 mt-2" data-id="element-83">
                  Every word earns its place on the page.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}